export default __webpack_public_path__ + "static/media/payroll-run-attendance-image-1.bf953105.svg";